/**
 * Main router for handling authenticated carrier redirects
 * Import carrier-specific handlers from ./carriers/ directory
 */

import { authenticateLibertyMutualBonds } from './carriers/liberty-mutual-bonds';
import { ClientConfigData } from '../api/types/config-response';

/**
 * Handles authenticated redirects based on product code
 * Routes to appropriate carrier-specific authentication handler
 * 
 * @param productCode The product code (e.g., "BONDS")
 * @param apiUrl The redirect URL from backend
 * @param clientConfig Client configuration containing all carrier credentials
 * @returns Promise that resolves when redirect is initiated
 */
export const handleAuthenticatedRedirect = (
    productCode: string,
    apiUrl: string,
    clientConfig: ClientConfigData
): Promise<void> => {
    return new Promise((resolve, reject) => {
        try {
            // Route to appropriate authentication handler based on product
            switch (productCode) {
                case "BONDS":
                    authenticateLibertyMutualBonds(apiUrl, {
                        customerId: clientConfig.libertyMutualBondsCustomerId,
                        accessCode: clientConfig.libertyMutualBondsAccessCode
                    });
                    resolve();
                    break;          
                default:
                    reject(new Error(`Unsupported authenticated product: ${productCode}`));
            }
        } catch (error) {
            reject(error);
        }
    });
};
